

import { initializeApp } from "firebase/app";
import {
    getAuth, GoogleAuthProvider, signInWithPopup, RecaptchaVerifier,
    signInWithPhoneNumber
} from 'firebase/auth';

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
//import auth from firebase

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: "interra-007",
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: "1039689068111",
    appId: "1:1039689068111:web:2c94d95657d64ef645c43a",
    measurementId: "G-QS0QK5TPVP"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

//This is Google Provider's Auth
const provider = new GoogleAuthProvider()
export const signInWithGoogle = () => {
    signInWithPopup(auth, provider)
        .then((result) => {
            console.log(result)
            localStorage.setItem('Name', (result.user.displayName))
            localStorage.setItem('Email', (result.user.email))
            localStorage.setItem('PhotoURL', (result.user.photoURL))
        })
        .catch((error) => {
            console.log(error)
        })

}

export const recaptaSetup = (number) => {
    const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);

    recaptchaVerifier.render();

    return signInWithPhoneNumber(auth, number, recaptchaVerifier)
}
export const db = getFirestore(app);
export const storage = getStorage();
// export default app;